import { BaseCrudService } from "@/services/base";
import { Reservation } from "@/swagger/models";

class ReservationService extends BaseCrudService<Reservation> {
    constructor() {
        super({
            apiPrefix: "reservations",
            entityName: "reservation",
        });
    }

    async getPresentUsers(customerId: number, officeId?: number): Promise<Reservation[]> {
        const res = await this.axios.get<Reservation[]>("/now", { params: { customer: customerId, office: officeId } });
        return res.data;
    }

    build(fields?: Partial<Reservation> & Pick<Reservation, "date" | "user" | "desk">): Reservation {
        return Object.assign(
            {
                date: "",
                user: null,
                desk: null,
                checkinAt: null,
                checkoutAt: null,
                slot: null,
                customer: null,
            },
            fields,
        );
    }
}

export const reservationService = new ReservationService();
